import { getTableColumn, TableColumn } from '@shared/UI';
import { useClientDetailsTable } from './MyPortfolioTableProvider';
import { getHeaderClassName } from '@shared/UI/SimpleTable/lib/getHeaderClassName';
import { HeaderCellWithFilter } from '@shared/UI/SimpleTable/components/HeaderCellWithFilter';
import { BiCaretDown, BiCaretUp } from 'react-icons/bi';

export function getTransactionsTableColumns(): TableColumn<any>[] {
    const { desc, sortFieldName, arrayWithLogos, AssignPositionBody } = useClientDetailsTable();

    const columns: TableColumn<any>[] = [
        getTableColumn({
            title: 'Description',
            flex: 0.15,
            formatter: (_, row) => {
                return (
                    <div className='portfolio__item-security'>
                        {/* <div className='portfolio__item-icon'>
                            {!!arrayWithLogos.find((item: any) => item.symbol === row.symbol)?.link ? (
                                <img
                                    className='positions-table-cell__logos'
                                    src={arrayWithLogos.find((item: any) => item.symbol === row.symbol)?.link}
                                    alt='logo'
                                />
                            ) : (
                                <div className='positions-table-cell__logos placeholder' />
                            )}
                        </div> */}
                        <div className='portfolio__item-details'>
                            <div className='portfolio__item-name'>{row.name}</div>
                        </div>
                    </div>
                );
            },
            headerClassName: `positions-table-header ${getHeaderClassName(sortFieldName, desc, 'symbol')}`,
            headerFormatter: (row) => (
                <HeaderCellWithFilter
                    title={String(row)}
                    icon={undefined}
                    onClick={() => null}
                />
            ),
        }),

        getTableColumn({
            title: 'Symbol',
            flex: 0.15,
            formatter: (_, row) => {
                return (
                    <div className='portfolio__item-security'>
                        {/* <div className='portfolio__item-icon'>
                            {!!arrayWithLogos.find((item: any) => item.symbol === row.symbol)?.link ? (
                                <img
                                    className='positions-table-cell__logos'
                                    src={arrayWithLogos.find((item: any) => item.symbol === row.symbol)?.link}
                                    alt='logo'
                                />
                            ) : (
                                <div className='positions-table-cell__logos placeholder' />
                            )}
                        </div> */}
                        <div className='portfolio__item-details'>
                            <div className='portfolio__item-symbol'>{row.symbol}</div>
                        </div>
                    </div>
                );
            },
            headerClassName: `positions-table-header ${getHeaderClassName(sortFieldName, desc, 'symbol')}`,
            headerFormatter: (row) => (
                <HeaderCellWithFilter
                    title={String(row)}
                    icon={undefined}
                    onClick={() => null}
                />
            ),
        }),

        getTableColumn({
            dataField: 'amountInvested',
            title: 'Investment',
            flex: 0.15,
            firstColumn: true,
            formatter: (_, row) => {
                return `${row.amountInvested}`; // Format as currency with two decimals
            },
            headerFormatter: (row) => (
                <HeaderCellWithFilter
                    title='Investment'
                    icon={undefined}
                    onClick={() => null}
                />
            ),
            headerClassName: `transactions-table-header ${getHeaderClassName(sortFieldName, desc, 'amountInvested')}`,
        }),

        getTableColumn({
            dataField: 'amountReturned',
            title: 'Return',
            flex: 0.15,
            firstColumn: true,
            formatter: (_, row) => {
                const caretColor = row.isPositive ? '#5ECF82' : '#EB3F3C';
                const textColor = caretColor;

                return (
                    <>
                        {row.isPositive ? (
                            <BiCaretUp style={{ color: caretColor }} />
                        ) : (
                            <BiCaretDown style={{ color: caretColor }} />
                        )}
                        <span style={{ color: textColor }}>{row.return}</span>
                    </>
                );
            },
            headerFormatter: (row) => (
                <HeaderCellWithFilter
                    title='Return'
                    icon={undefined}
                    onClick={() => null}
                />
            ),
            headerClassName: `transactions-table-header ${getHeaderClassName(sortFieldName, desc, 'amountReturned')}`,
        }),

        getTableColumn({
            dataField: 'investmentPercentage',
            title: 'Allocation %',
            flex: 0.1,
            firstColumn: true,
            formatter: (_, row) => {
                return `${row.percentage}`; // Format percentage with two decimals and add '%' symbol
            },
            headerFormatter: (row) => (
                <HeaderCellWithFilter
                    title='Allocation %'
                    icon={undefined}
                    onClick={() => null}
                />
            ),
            headerClassName: `transactions-table-header ${getHeaderClassName(sortFieldName, desc, 'investmentPercentage')}`,
        }),
    ];

    return columns;
}
